// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file job_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { JobCategory, JobCategoryJson, JobStatus, JobStatusJson, JobType, JobTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { File, FileJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { DateTimeFilter, DateTimeFilterJson, ListFilter, ListFilterJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { JobCreateSchema, JobFileUploadRequestSchema, JobListSchema, JobSchema, JobUpdateSchema } from "./job_pb";
import { file_job } from "./job_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file job_service.proto.
 */
export const file_job_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_enums, file_file_upload, file_general, file_job]);

/**
 * @generated from message raccoonai.JobListRequest
 */
export type JobListRequest = Message<"raccoonai.JobListRequest"> & {
  /**
   * @generated from field: repeated uint64 service_receiver_ids = 1 [json_name = "service_receiver_ids"];
   */
  serviceReceiverIds: bigint[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 3 [json_name = "job_types"];
   */
  jobTypes: JobType[];

  /**
   * @generated from field: repeated raccoonai.JobCategory job_categories = 4 [json_name = "job_categories"];
   */
  jobCategories: JobCategory[];

  /**
   * @generated from field: repeated raccoonai.JobStatus job_statuses = 5 [json_name = "job_statuses"];
   */
  jobStatuses: JobStatus[];

  /**
   * @generated from field: optional uint64 driver_id = 6 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * facets: "status" (JobStatus), "category" (JobCategory), "totals" (JobTotal).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 11 [json_name = "time_filter"];
   */
  timeFilter?: DateTimeFilter;

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 12 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * Only jobs created with these pickup location groups (jobs created before
   * the group-based flow carry no group and never match this filter).
   *
   * @generated from field: repeated uint64 pickup_location_group_ids = 13 [json_name = "pickup_location_group_ids"];
   */
  pickupLocationGroupIds: bigint[];

  /**
   * Specific jobs by id. Lets a caller that already has a set of job ids — e.g.
   * from GovDashService.ListAiVerifications — fetch those jobs in full.
   *
   * @generated from field: repeated uint64 job_ids = 14 [json_name = "job_ids"];
   */
  jobIds: bigint[];

  /**
   * Matched against the job id, the service receiver name and the pickup location
   * name. Server-side so it composes with list_filter; searching one page would mislead.
   *
   * @generated from field: optional string search = 15;
   */
  search: string;

  /**
   * Jobs whose shift belongs to any of these drivers. driver_id (6) predates this and
   * stays for existing callers; new callers pass driver_ids.
   *
   * @generated from field: repeated uint64 driver_ids = 16 [json_name = "driver_ids"];
   */
  driverIds: bigint[];

  /**
   * true → only jobs with at least one photo report (legacy report URLs or an uploaded
   * file); false → only jobs with none. Absent → no photo filtering.
   *
   * @generated from field: optional bool has_photo_report = 17 [json_name = "has_photo_report"];
   */
  hasPhotoReport: boolean;

  /**
   * true → one job per order (the jobs sharing an order_number): the one whose status is
   * the order's — its newest completed job if it has one, otherwise its newest job. The
   * other filters then select orders by that job, and the total and the facets count
   * orders. A job without an order number is an order of its own.
   *
   * @generated from field: optional bool one_per_order = 18 [json_name = "one_per_order"];
   */
  onePerOrder: boolean;

  /**
   * Only the jobs of these orders, e.g. every attempt at an order the caller opened.
   *
   * @generated from field: repeated string order_numbers = 19 [json_name = "order_numbers"];
   */
  orderNumbers: string[];

  /**
   * With service_provider_ids set, they name the executors only: jobs the callers' responsible zones
   * show are left out. Unset or false keeps the zone-visible list; without service_provider_ids it has
   * no effect. Servers before this field ignore it.
   *
   * @generated from field: optional bool executed_only = 20 [json_name = "executed_only"];
   */
  executedOnly: boolean;
};

/**
 * @generated from message raccoonai.JobListRequest
 */
export type JobListRequestJson = {
  /**
   * @generated from field: repeated uint64 service_receiver_ids = 1 [json_name = "service_receiver_ids"];
   */
  service_receiver_ids?: string[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 3 [json_name = "job_types"];
   */
  job_types?: JobTypeJson[];

  /**
   * @generated from field: repeated raccoonai.JobCategory job_categories = 4 [json_name = "job_categories"];
   */
  job_categories?: JobCategoryJson[];

  /**
   * @generated from field: repeated raccoonai.JobStatus job_statuses = 5 [json_name = "job_statuses"];
   */
  job_statuses?: JobStatusJson[];

  /**
   * @generated from field: optional uint64 driver_id = 6 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * facets: "status" (JobStatus), "category" (JobCategory), "totals" (JobTotal).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 11 [json_name = "time_filter"];
   */
  time_filter?: DateTimeFilterJson;

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 12 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * Only jobs created with these pickup location groups (jobs created before
   * the group-based flow carry no group and never match this filter).
   *
   * @generated from field: repeated uint64 pickup_location_group_ids = 13 [json_name = "pickup_location_group_ids"];
   */
  pickup_location_group_ids?: string[];

  /**
   * Specific jobs by id. Lets a caller that already has a set of job ids — e.g.
   * from GovDashService.ListAiVerifications — fetch those jobs in full.
   *
   * @generated from field: repeated uint64 job_ids = 14 [json_name = "job_ids"];
   */
  job_ids?: string[];

  /**
   * Matched against the job id, the service receiver name and the pickup location
   * name. Server-side so it composes with list_filter; searching one page would mislead.
   *
   * @generated from field: optional string search = 15;
   */
  search?: string;

  /**
   * Jobs whose shift belongs to any of these drivers. driver_id (6) predates this and
   * stays for existing callers; new callers pass driver_ids.
   *
   * @generated from field: repeated uint64 driver_ids = 16 [json_name = "driver_ids"];
   */
  driver_ids?: string[];

  /**
   * true → only jobs with at least one photo report (legacy report URLs or an uploaded
   * file); false → only jobs with none. Absent → no photo filtering.
   *
   * @generated from field: optional bool has_photo_report = 17 [json_name = "has_photo_report"];
   */
  has_photo_report?: boolean;

  /**
   * true → one job per order (the jobs sharing an order_number): the one whose status is
   * the order's — its newest completed job if it has one, otherwise its newest job. The
   * other filters then select orders by that job, and the total and the facets count
   * orders. A job without an order number is an order of its own.
   *
   * @generated from field: optional bool one_per_order = 18 [json_name = "one_per_order"];
   */
  one_per_order?: boolean;

  /**
   * Only the jobs of these orders, e.g. every attempt at an order the caller opened.
   *
   * @generated from field: repeated string order_numbers = 19 [json_name = "order_numbers"];
   */
  order_numbers?: string[];

  /**
   * With service_provider_ids set, they name the executors only: jobs the callers' responsible zones
   * show are left out. Unset or false keeps the zone-visible list; without service_provider_ids it has
   * no effect. Servers before this field ignore it.
   *
   * @generated from field: optional bool executed_only = 20 [json_name = "executed_only"];
   */
  executed_only?: boolean;
};

/**
 * Describes the message raccoonai.JobListRequest.
 * Use `create(JobListRequestSchema)` to create a new message.
 */
export const JobListRequestSchema: GenMessage<JobListRequest, {jsonType: JobListRequestJson}> = /*@__PURE__*/
  messageDesc(file_job_service, 0);

/**
 * @generated from message raccoonai.JobRequest
 */
export type JobRequest = Message<"raccoonai.JobRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 service_receiver_id = 2 [json_name = "service_receiver_id"];
   */
  serviceReceiverId: bigint;

  /**
   * @generated from field: required uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;
};

/**
 * @generated from message raccoonai.JobRequest
 */
export type JobRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 service_receiver_id = 2 [json_name = "service_receiver_id"];
   */
  service_receiver_id?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;
};

/**
 * Describes the message raccoonai.JobRequest.
 * Use `create(JobRequestSchema)` to create a new message.
 */
export const JobRequestSchema: GenMessage<JobRequest, {jsonType: JobRequestJson}> = /*@__PURE__*/
  messageDesc(file_job_service, 1);

/**
 * @generated from message raccoonai.OperationTwJobListRequest
 */
export type OperationTwJobListRequest = Message<"raccoonai.OperationTwJobListRequest"> & {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];
};

/**
 * @generated from message raccoonai.OperationTwJobListRequest
 */
export type OperationTwJobListRequestJson = {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];
};

/**
 * Describes the message raccoonai.OperationTwJobListRequest.
 * Use `create(OperationTwJobListRequestSchema)` to create a new message.
 */
export const OperationTwJobListRequestSchema: GenMessage<OperationTwJobListRequest, {jsonType: OperationTwJobListRequestJson}> = /*@__PURE__*/
  messageDesc(file_job_service, 2);

/**
 * @generated from message raccoonai.AttachJobInstructionsRequest
 */
export type AttachJobInstructionsRequest = Message<"raccoonai.AttachJobInstructionsRequest"> & {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: repeated raccoonai.File files = 3;
   */
  files: File[];
};

/**
 * @generated from message raccoonai.AttachJobInstructionsRequest
 */
export type AttachJobInstructionsRequestJson = {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: repeated raccoonai.File files = 3;
   */
  files?: FileJson[];
};

/**
 * Describes the message raccoonai.AttachJobInstructionsRequest.
 * Use `create(AttachJobInstructionsRequestSchema)` to create a new message.
 */
export const AttachJobInstructionsRequestSchema: GenMessage<AttachJobInstructionsRequest, {jsonType: AttachJobInstructionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_job_service, 3);

/**
 * @generated from message raccoonai.DetachJobInstructionsRequest
 */
export type DetachJobInstructionsRequest = Message<"raccoonai.DetachJobInstructionsRequest"> & {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: repeated uint64 file_ids = 3 [json_name = "file_ids"];
   */
  fileIds: bigint[];
};

/**
 * @generated from message raccoonai.DetachJobInstructionsRequest
 */
export type DetachJobInstructionsRequestJson = {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: repeated uint64 file_ids = 3 [json_name = "file_ids"];
   */
  file_ids?: string[];
};

/**
 * Describes the message raccoonai.DetachJobInstructionsRequest.
 * Use `create(DetachJobInstructionsRequestSchema)` to create a new message.
 */
export const DetachJobInstructionsRequestSchema: GenMessage<DetachJobInstructionsRequest, {jsonType: DetachJobInstructionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_job_service, 4);

/**
 * @generated from service raccoonai.JobService
 */
export const JobService: GenService<{
  /**
   * @generated from rpc raccoonai.JobService.CreateJob
   */
  createJob: {
    methodKind: "unary";
    input: typeof JobCreateSchema;
    output: typeof JobSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.GetJobById
   */
  getJobById: {
    methodKind: "unary";
    input: typeof JobRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.UpdateJob
   */
  updateJob: {
    methodKind: "unary";
    input: typeof JobUpdateSchema;
    output: typeof JobSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.ListJobs
   */
  listJobs: {
    methodKind: "unary";
    input: typeof JobListRequestSchema;
    output: typeof JobListSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.ListOperationTimeWindowJobs
   */
  listOperationTimeWindowJobs: {
    methodKind: "unary";
    input: typeof OperationTwJobListRequestSchema;
    output: typeof JobListSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.CancelJob
   */
  cancelJob: {
    methodKind: "unary";
    input: typeof JobRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.ForceCompleteJob
   */
  forceCompleteJob: {
    methodKind: "unary";
    input: typeof JobRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * A new attempt at a NOT_COMPLETED job's order, today at its hours; once per attempt.
   *
   * @generated from rpc raccoonai.JobService.ReissueJob
   */
  reissueJob: {
    methodKind: "unary";
    input: typeof JobRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.AttachJobInstructions
   */
  attachJobInstructions: {
    methodKind: "unary";
    input: typeof AttachJobInstructionsRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.DetachJobInstructions
   */
  detachJobInstructions: {
    methodKind: "unary";
    input: typeof DetachJobInstructionsRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.JobService.DetachJobFromRoute
   */
  detachJobFromRoute: {
    methodKind: "unary";
    input: typeof JobRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * The office's UploadJobFile: one before/after photo added post factum to a
   * COMPLETED or FORCE_COMPLETED job, when the driver could not. Needs can_edit
   * on the job.
   *
   * @generated from rpc raccoonai.JobService.UploadJobFile
   */
  uploadJobFile: {
    methodKind: "unary";
    input: typeof JobFileUploadRequestSchema;
    output: typeof MessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_job_service, 0);

